import { UserBase } from '../resources/types';

type EventType = 'apiError' | 'formQuestionSubmitted' | 'Appointment_Requested';

type EventData = {
  event: EventType;
  [field: string]: any;
};

type CurrentUser = UserBase & {
  masterAccountName?: string;
};

export function trackEvent(data: EventData) {
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push(data);
}

export function trackFormQuestionSubmitted(formId: string, formQuestionId: string, formQuestionIndex: number) {
  trackEvent({
    event: 'formQuestionSubmitted',
    formId,
    formQuestionId,
    formQuestionIndex,
  });
}

export function trackUser(user: CurrentUser) {
  if (!(window as any).dataLayer) {
    return;
  }
  const {
    id,
    email,
    createdAt,
    roles,
    master,
    doNotContact,
    organization,
    lastLogin,
    type,
    name,
    masterAccountName,
  } = user;

  const masterAccountNameToTrack = type !== 'patient' ? masterAccountName : '';
  const userNameToTrack = type !== 'patient' ? name : '';
  const isDemoUser = /^demo\+/.test(email);

  (window as any).dataLayer.push({
    event: 'luma-app-loaded',
    createdAt,
    email,
    id,
    isDemoUser,
    isMasterAccount: master,
    isDoNotContact: doNotContact,
    isOrganizationAccount: Boolean(organization),
    lastLoginAt: lastLogin,
    masterAccountName: masterAccountNameToTrack,
    name: userNameToTrack,
    roles,
    user: user.user,
    type,
  });

  // when we install the chameleon in the app (chmln.init from chmln npm package or in GTM), it adds a global chmln object to the window
  const chmln = (window as any).chmln as { identify: (id: string, data: any) => void } | undefined;

  if (chmln && !isDemoUser) {
    chmln.identify(id, {
      email,
      created: createdAt,
      name: userNameToTrack,
      company: {
        uid: user.user,
        name: masterAccountNameToTrack,
      },
    });
  }
}
